<quill-editor [modules]="options" [formControl]="control"></quill-editor>

